import React from 'react'
import { makeStyles } from '@material-ui/styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import style from './style.js'

const useStyles = makeStyles(style)

const LinearProgressBar = ({
  showValue = false,
  value = 0,
  isLoading,
  styles = {},
  newDesign,
}) => {
  const classes = useStyles()
  return (
    <Box className={classes.progressWrapper} style={styles}>
      {showValue ? (
        <Typography
          className={newDesign ? classes.valueV2 : classes.value}
        >{`${value}%`}</Typography>
      ) : null}

      <Box style={{ width: '100%' }}>
        {isLoading ? (
          <LinearProgress
            className={newDesign ? classes.progressV2 : classes.progress}
          />
        ) : (
          <LinearProgress
            className={newDesign ? classes.progressV2 : classes.progress}
            variant="determinate"
            value={value}
          />
        )}
      </Box>
    </Box>
  )
}

export default LinearProgressBar
